import { resolve } from 'redux-optimist-promise';

export const SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';

export const SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';

export const TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
export const TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';

export const FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
export const FETCH_USER_PAST_TRIPS_RESOLVED = resolve(FETCH_USER_PAST_TRIPS);
export const RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';

export const FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
export const FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
export const FETCH_USER_FUTURE_TRIPS_RESOLVED = resolve(FETCH_USER_FUTURE_TRIPS);
export const RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';

export const FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
export const FETCH_USER_SEARCHES_RESOLVED = resolve(FETCH_USER_SEARCHES);

export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';

export const FETCH_CALENDAR = 'FETCH_CALENDAR';
export const FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';

export const CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
export const CLEAR_CALENDAR = 'CLEAR_CALENDAR';

export const QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
export const QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';

export const UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';
